
export class Authorization {
    _authorization: string;
    _CSRFToken: string;

    setCSRFToken(val: string) {
        this._CSRFToken = val;
    }
    get CSRFToken() {
        return this._CSRFToken;
    }
    
    get authorization() {
        return this._authorization;
    }
    setAuthorization(val: string) {
        this._authorization = val;
    }
}
